<template>
  <div class="login">
    <div style="width:100%;text-align:center">
    <!--logo-->
    <div class="head" style="text-align:center;margin-top:140px;margin-bottom:20px;width:100%">
      <img :src="logoUrl" style="max-width:300px;max-height:180px" />
    </div>
    <!--登录组件-->
    <div class="main-box" >
      <h1 style="margin:10px">{{title}}</h1>
      <div class="main-login">
        <!-- 用户登录 -->
        <div class="userLogin">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- 账号 -->
            <el-form-item prop="tel">
              <el-input
                size="medium"
                type="text"
                v-model.trim="ruleForm.tel"
                prefix-icon="el-icon-user-solid"
                autocomplete="off"
                placeholder="请输入客户代码"
                @keyup.enter.native="submitLogin('ruleForm')"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item prop="pass">
              <el-input
                type="password"
                size="medium"
                v-model.trim="ruleForm.pass"
                prefix-icon="el-icon-s-goods"
                autocomplete="off"
                placeholder="密码"
                @keyup.enter.native="submitLogin('ruleForm')"
              ></el-input>
            </el-form-item>
            <!-- 登录按钮 -->
            <el-form-item class="form-item">
              <el-button type="primary" @click="submitLogin('ruleForm')" size="medium">登录</el-button>
            </el-form-item>
            <!-- 注册 -->
            <div class="registered">
                <el-tooltip class="item" effect="dark" content="请联系系统管理员或业务" placement="top-start">
                    <div class="registered_left">无法登录？</div>
                </el-tooltip>
                <el-link
                  v-if="wxConfigAvailable"
                  type="primary"
                  :underline="false"
                  @click="openWxLoginDialog"
                  class="registered_r">
                  微信登录
                </el-link>
            </div>
          </el-form>
        </div>
        <el-dialog
          :visible.sync="msgDialogVisible"
          :close-on-click-modal="false"
          width="342px"
          :modal-append-to-body = "false">
          <Wxlogin
            id="wxLoginForm"
            :appid="appid"
            :scope="scope"
            :redirect_uri="redirect_uri"
            v-if="wxConfigAvailable"
          ></Wxlogin>
          <div v-else class="wx-config-error">
            微信登录暂不可用，请联系管理员配置
          </div>
        </el-dialog>
        <!-- 短信验证 -->
      </div>
    </div>
    <!--备案号显示（居底）-->
    <div class="footer" >
      <p>{{record}}</p>
      <p v-show="company">©2024{{company}}版权所有</p>
    </div>
    </div>
  </div>
</template>
<script>
//引入api
import httpApi from "@/http/api";

import Wxlogin from "vue-wxlogin"
export default {
  components: {
    Wxlogin // 声明引用组件
  },
  data() {
    //正则账号验证
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    //正则密码验证
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      appid: "", // 应用唯一标识，在微信开放平台提交应用审核通过后获得
      scope: "snsapi_login", // 应用授权作用域，网页应用目前仅填写snsapi_login即可
      redirect_uri: "", // 重定向地址 （回调地址）
      msgDialogVisible: false,
      wxConfigAvailable: false, // 微信配置是否可用
      logoUrl: "",
      title: "",
      record: "",
      company: "",
      ruleForm: {
        //账号
        tel: "",
        //密码
        pass: ""
      },
      //正则
      rules: {
        tel: [{ validator: validatePass, trigger: "blur" }],
        pass: [{ validator: validatePass2, trigger: "blur" }]
      },
      code:""
    };
  },
  methods: {
    //获取登录页log
    init(){
      let that = this;
      httpApi
        .listParams({
          params: {
            type: "sys_config",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code == "ok" && res.data.data && res.data.data.length > 0) {
            that.logoUrl = res.data.data[0].logoPortalUrl;
            that.title = res.data.data[0].title;
            that.record = res.data.data[0].record;
            that.company = res.data.data[0].company;
          } else {
            console.warn("获取系统配置失败或无数据");
          }
        })
        .catch((error) => {
          console.error("获取系统配置异常:", error);
          that.$message.error("获取系统配置失败，请稍后重试");
        });
    },
    initWeixin(){
      return new Promise((resolve, reject) => {
        let that = this;
        httpApi
          .listParams({
            params: {
              type: "sys_weixin",
              enable: "1",
            },
          })
          .then((res) => {
            if (res.data.code == "ok" && res.data.data && res.data.data.length > 0) {
              const weixinConfig = res.data.data[0];
              if (weixinConfig.appid && weixinConfig.encodeUrl) {
                that.redirect_uri = encodeURI("http://"+weixinConfig.encodeUrl+"/login");
                that.appid = weixinConfig.appid;
                that.wxConfigAvailable = true;
              } else {
                that.wxConfigAvailable = false;
                console.warn("微信配置不完整，缺少 appid 或 encodeUrl");
              }
            } else {
              that.wxConfigAvailable = false;
              console.warn("获取微信配置失败或无数据");
            }
            resolve();
          })
          .catch((error) => {
            that.wxConfigAvailable = false;
            console.error("获取微信配置异常:", error);
            reject(error);
          });
      });
    },
    submitLogin(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          //登录
          httpApi
            .submitLogin({
              account: that.ruleForm.tel,
              password: that.ruleForm.pass
            })
            .then(res => {
              if (res.data.code == "ok") {
                //令牌存储到临时缓存
                sessionStorage.setItem("token", res.data.data.token);
                // localStorage.setItem("refToken", res.data.data.refreshToken);
                //登录成功
                // that.$message.success("登录成功！");
                //跳转首页
                that.$router.push("/");
              } else {
                that.$message.error(res.data.message || "登录失败，请检查账号密码");
              }
            })
            .catch((error) => {
              console.error("登录请求异常:", error);
              that.$message.error("登录请求失败，请稍后重试");
            });
        } else {
          return false;
        }
      });
    },
    fastLogin() {
      let that = this;
      const url = document.location.toString();
      
      // 检查URL中是否有code参数
      if (url.indexOf("?") !== -1 && url.indexOf("=") !== -1) {
        const urlParmStr = url.slice(url.indexOf("=") + 1);
        if (urlParmStr) {
          httpApi.fastLogin({ token: urlParmStr }).then(res => {
            if (res.data.code == "ok") {
              //令牌存储到临时缓存
              sessionStorage.setItem("token", res.data.data.token);
              localStorage.setItem("refToken", res.data.data.refreshToken);
              //登录成功
              // that.$message.success("登录成功！");
              //跳转首页
              that.$router.push("/");
            } else {
              that.$message.error(res.data.message || "自动登录失效！");
            }
          }).catch((error) => {
            console.error("快速登录异常:", error);
            that.$message.error("快速登录失败，请稍后重试");
          });
        }
      }
      
      // 加载图标和标题配置
      httpApi
        .listParams({
          params: {
            type: "sys_config",
            enable:"1"
          }
        })
        .then(ress => {
          if (ress.data.code == "ok" && ress.data.data && ress.data.data.length > 0) {
            const config = ress.data.data[0];
            sessionStorage.setItem("ico", config.ico);
            sessionStorage.setItem("title", config.title);
            const ico = sessionStorage.getItem('ico');
            let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = ico;
            document.getElementsByTagName('head')[0].appendChild(link);
          } else {
            console.warn("获取配置失败或无数据");
          }
        })
        .catch((error) => {
          console.error("获取配置异常:", error);
        });
    },
    openWxLoginDialog() {
      if (!this.wxConfigAvailable) {
        this.$message.warning("微信登录暂不可用，请联系管理员配置");
        return;
      }
      this.msgDialogVisible = true;
    },
    wxLogin() {
      if (!this.wxConfigAvailable) {
        console.warn("微信配置不可用，跳过微信登录");
        return;
      }
      
      if (this.code && this.code.trim()) {
        //登录
        httpApi
          .wxLogin({
            params: {
              code: this.code
            }
          })
          .then(res => {
            if (res.data.code == "ok") {
              //令牌存储到临时缓存
              sessionStorage.setItem("token", res.data.data.token);
              // localStorage.setItem("refToken", res.data.data.refreshToken);
              //登录成功
              // that.$message.success("登录成功！");
              //跳转首页
              this.$router.push("/");
            } else {
              this.$message.error(res.data.message || "微信登录失败");
            }
          })
          .catch((error) => {
            console.error("微信登录异常:", error);
            this.$message.error("微信登录请求失败，请稍后重试");
          });
      }
    }
  },
  created() {
    this.code = this.$route.query.code;
    this.init();
    this.initWeixin().then(() => {
      // 微信配置加载完成后调用微信登录
      this.wxLogin();
      // 微信登录失败或未执行时，尝试快速登录作为备用
      if (!this.wxConfigAvailable || !this.code) {
        this.fastLogin();
      }
    }).catch(() => {
      // 微信配置加载失败时，尝试快速登录
      this.fastLogin();
    });

    //回车键直接登录
    const that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      //需要注意的：that.$route.path==''/login'的作用是如果不判断，回车可能所有页面都生效，也就是无论在哪个页面敲回车都会直接登录
      if (that.$route.path == "/login" && keycode == 13) {
        that.submitLogin("ruleForm");
        return false;   
      }
    };
  },
  beforeDestroy() {
    // 销毁事件监听，防止内存泄漏
    document.onkeypress = null;
  }
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  background: url("../assets/beijing.png") no-repeat;
  background-attachment:fixed;
  flex-direction: column;
  background-size:cover;
  background-position:center;
  background-repeat:no-repeat;
  .head{
  width: 100%; 

  }
  .main-box {
    border-radius: 10px;
    max-width: 500px;
    min-width: 350px;
    width: 90%;
    height: auto;
    margin: auto;
    display:flex;flex-direction:column;margin-bottom: 20px;
    background: #ffffff;
    border: #888 0px solid;
    filter: progid:DXImageTransform.Microsoft.Shadow(color=#888, strength=4);
    -moz-box-shadow: 0 0 50px #888;
    -webkit-box-shadow: 0 0 50px #888;
    box-shadow: 0 0 25px #888;
    h1 {
      margin-top: 20px;
      text-align: center;
      font-size: 22px;
    }
    .main-login {
      margin: 40px;
      //用户登录
      .userLogin {
        font-size: 14px;
        /deep/.el-form-item__content {
          margin: 0 20px !important;
        }
        .el-button {
          width: 100% !important;
          margin: 0 !important;
        }
        /deep/.form-item {
          margin: 10px 0px;
        }
        .CLogin {
          width: 100%;
          height: 40px;
          line-height: 40px;
          .CLogin_left {
            float: left;
            margin-left: 20px;
            cursor: pointer;
          }
          .CLogin_r {
            float: right;
            margin-right: 20px;
            cursor: pointer;
          }
        }
        .registered {
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #72b3e6;
          .registered_left {
            float: left;
            margin-left: 20px;
            cursor: pointer;
          }
          .registered_r {
            float: right;
            margin-right: 20px;
            cursor: pointer;
          }
        }
      }   

    }
    }
  
  .footer{
      height: auto;
      line-height: 30px;
      position: absolute;
      bottom: 2em;
      width: 100%;
      display: flex;
      text-align: center;
      color: #f2f5f7;
      font-size: 14px;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      }
      
    @media (max-width: 430px) {
    .footer{
      bottom:6vh;
      
    }}

    @media (min-width: 430px) and (max-width: 786px) {
    .footer{
      bottom:4em;
      
    }}
  }

</style>
